import { ColorType, Label, LabelType } from '../_ui';

interface StatusPillProps {
  label: string;
  borderColor: ColorType;
  labelColor: ColorType;
  /** A {@link ColorType} or a raw token (e.g. 'white') for the background. */
  bgColor: ColorType | string;
}

/**
 * Rounded status pill shared by the promotion and promo-code status indicators.
 *
 * The `border-*`/`bg-*` classes are built dynamically from the color tokens, so every
 * color passed in here MUST be present in the tailwind.config.js safelist — otherwise
 * the JIT purge strips it and the pill renders colorless.
 */
export const StatusPill = ({ label, borderColor, labelColor, bgColor }: StatusPillProps) => (
  <div
    className={`px-2 py-0.5 gap-1 border-2 border-${borderColor} bg-${bgColor} rounded-3xl box-border flex flex-row items-center h-6 whitespace-nowrap w-max overflow-hidden`}
  >
    <Label text={label} type={LabelType.BODY3} color={labelColor} />
  </div>
);
